<div class="login_wrapper">
    <img src="/assets/images/logo-mark.svg" class="login_logo" alt="" />

    <div class="login_content">
        <div class="login_box">
            <form [formGroup]="loginForm">
                <div class="login_box_inner">
                    <img
                        src="/assets/images/logo.svg"
                        class="login_logo"
                        alt=""
                    />
                    <p class="welcome_text_login">Sign in to Phonetik</p>
                    <p class="welcome_sub_text_login">
                        Access your account to continue
                    </p>
                    <hr style="border-color: #2a3238" />

                    <div class="login_control mb_16">
                        <p class="login_password_label">Email</p>
                        <input
                            type="text"
                            class="form-control login_form_control"
                            formControlName="email"
                            placeholder="Enter your Email"
                        />
                    </div>
                    <div
                        *ngIf="
                            loginForm.get('email')?.invalid &&
                            loginForm.get('email')?.touched
                        "
                        class="text-danger"
                    >
                        Enter your Email.
                    </div>
                    <div class="login_control mb_8">
                        <p class="login_password_label">Password</p>
                        <input
                            type="password"
                            [type]="passwordVisible ? 'text' : 'password'"
                            class="form-control login_form_control"
                            formControlName="password"
                            placeholder="Enter your password"
                        />
                        <i
                            class="fa fa-eye-slash password_eye_login"
                            aria-hidden="true"
                            *ngIf="!passwordVisible"
                            (click)="togglePasswordVisibility()"
                        ></i>
                        <i
                            class="fa fa-eye password_eye_login"
                            aria-hidden="true"
                            *ngIf="passwordVisible"
                            (click)="togglePasswordVisibility()"
                        ></i>
                    </div>
                    <div
                        *ngIf="
                            loginForm.get('password')?.invalid &&
                            loginForm.get('password')?.touched
                        "
                        class="text-danger"
                    >
                        Password is required.
                    </div>
                    <div class="forget_password">
                        <a
                            routerLink="/reset-password"
                            class="forgot_password_btn"
                            >Forgot Password?</a
                        >
                    </div>
                    <div class="login_form_footer">
                        <a [routerLink]="['/signup']" class="have_account"
                            >Don’t have an account? Sign Up</a
                        >

                        <div *ngIf="islogin" class="loader_div">
                            <button
                                class="btn continue_login_btn_forgot"
                                type="submit"
                            >
                                <span
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Loading...
                            </button>
                        </div>
                        <button
                            *ngIf="!islogin"
                            class="btn continue_login_btn"
                            (click)="loginUser()"
                        >
                            Sign In
                        </button>
                    </div>
                    <!-- <a [routerLink]="['./']" class="btn invitation_text_btn">I have an Invitation Code</a> -->
                </div>
            </form>
            <div class="login_box_inner" style="display: none">
                <p class="welcome_text_login"><span>Sign Up</span></p>
                <div class="login_control mb_24">
                    <p class="login_password_label">Email ID</p>
                    <input
                        type="text"
                        class="form-control login_form_control"
                        placeholder="Enter your Email ID"
                    />
                </div>
                <div class="login_control mb_24">
                    <p class="login_password_label">Confirm Password</p>
                    <input
                        type="password"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <div class="login_control mb_75">
                    <p class="login_password_label">Confirm Password</p>
                    <input
                        type="password"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <a [routerLink]="['./']" class="btn continue_login_btn"
                    >Sign Up</a
                >
                <p class="have_account">
                    Already have an account?
                    <a [routerLink]="['./']" class="have_account_btn">Login</a>
                </p>
                <a [routerLink]="['./']" class="btn invitation_text_btn"
                    >I have an Invitation Code</a
                >
            </div>
            <div
                class="login_box_inner details_form_inner"
                style="display: none"
            >
                <div class="detail_heading_box">
                    <p class="provide_heading">
                        Please provide us your Basic details, and you are good
                        to go!
                    </p>
                    <p class="enter_heading">Enter your basic details</p>
                    <p class="details_heading">Basic Details</p>
                </div>
                <div class="details_from_box">
                    <div class="row">
                        <div
                            class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                        >
                            <div class="login_control mb_16">
                                <p class="login_password_label">First Name</p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter your first name"
                                />
                            </div>
                        </div>
                        <div
                            class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                        >
                            <div class="login_control mb_16">
                                <p class="login_password_label">Last Name</p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter your last name"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">Phone Number</p>
                                <input
                                    type="number"
                                    class="form-control login_form_control"
                                    placeholder="Enter phone number"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">Company Name</p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter your company name"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">
                                    Company Address line 1
                                </p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter Address"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">
                                    Company Address line 2
                                    <span class="optional_text"
                                        >(Optional)</span
                                    >
                                </p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter Address"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">Town/City</p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter city"
                                />
                            </div>
                        </div>
                        <div
                            class="col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
                        >
                            <div class="login_control mb_16">
                                <p class="login_password_label">
                                    State / province / county
                                    <span class="optional_text"
                                        >(optional)</span
                                    >
                                </p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter state/ province/ country"
                                />
                            </div>
                        </div>
                        <div
                            class="col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                        >
                            <div class="login_control mb_16">
                                <p class="login_password_label">Postcode</p>
                                <input
                                    type="text"
                                    class="form-control login_form_control"
                                    placeholder="Enter Postcode"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_16">
                                <p class="login_password_label">Country</p>
                                <select
                                    class="form-select login_form_control"
                                    aria-label="Default select example"
                                >
                                    <option selected>The United States</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="login_control mb_24">
                                <p class="login_password_label">
                                    Profile Image
                                </p>
                                <div class="input-group image_input_group">
                                    <input
                                        type="file"
                                        class="form-control login_form_control"
                                        id="inputGroupFile01"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-check login_details_check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault1"
                                />
                                <label
                                    class="form-check-label"
                                    for="flexRadioDefault1"
                                >
                                    I accept refund policy and auto-renewal
                                    policy.
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="details_btn_group">
                                <a
                                    [routerLink]="['./']"
                                    class="btn password_cancel_btn"
                                    >Cancel</a
                                >
                                <a
                                    [routerLink]="['./']"
                                    class="btn password_next_btn"
                                    >Continue</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="login_box_inner" style="display: none">
                <div class="forgot_box">
                    <p class="forgot_heading">Forgot Password?</p>
                    <p class="forgot_sub_heading">
                        We’ve sent a password reset link to
                        <span>maria_smith@example.com</span> Please check your
                        inbox and follow the instructions to reset your password
                    </p>
                </div>
                <div class="password_btn_group password_bottom_pading">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Resend Link</a
                    >
                </div>
            </div>
            <div class="login_box_inner" style="display: none">
                <p class="create_password_heading">Create Password</p>
                <div class="login_control mb_24">
                    <p class="login_password_label">Create Password</p>
                    <input
                        type="password"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <div class="login_control mb_24">
                    <p class="login_password_label">Confirm Password</p>
                    <input
                        type="password"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <div class="password_btn_group password_bottom_pading">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Next</a
                    >
                </div>
            </div>
            <div class="login_box_inner" style="display: none">
                <div class="sorry_box">
                    <p class="sorry_heading">Sorry!</p>
                    <p class="sorry_sub_heading">
                        We couldn’t find an account associated with the provided
                        email\ address. Please double-check and try again.
                    </p>
                </div>

                <div class="password_btn_group sorry_padding">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Next</a
                    >
                </div>
            </div>
            <div class="login_box_inner" style="display: none">
                <p class="create_password_heading">Enter Invitation Code</p>
                <div class="login_control mb_24">
                    <p class="login_password_label">Enter invitation code</p>
                    <input
                        type="text"
                        class="form-control login_form_control"
                        placeholder="Enter invitation code"
                    />
                </div>
                <div class="password_btn_group invitation_padding">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Next</a
                    >
                </div>
            </div>
            <div class="login_box_inner" style="display: none">
                <p class="welcome_text_email">
                    <span>Welcome</span>maria_smith@example.com!
                </p>
                <p class="were_text">
                    You were invited by Nick Baker as an administrator for
                    phonetik.ai
                </p>
                <div class="password_btn_group welcome_padding">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Next</a
                    >
                </div>
            </div>
            <div class="login_box_inner" style="display: none">
                <p class="create_password_heading">Create Password</p>
                <div class="login_control mb_24">
                    <p class="login_password_label">Create Password</p>
                    <input
                        type="text"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <div class="login_control mb_24">
                    <p class="login_password_label">Confirm Password</p>
                    <input
                        type="text"
                        class="form-control login_form_control"
                        placeholder="Enter new password"
                    />
                    <i
                        class="fa fa-eye-slash password_eye_login"
                        aria-hidden="true"
                        *ngIf="!passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                    <i
                        class="fa fa-eye password_eye_login"
                        aria-hidden="true"
                        *ngIf="passwordVisible"
                        (click)="togglePasswordVisibility()"
                    ></i>
                </div>
                <div class="password_btn_group password_bottom_pading">
                    <a [routerLink]="['./']" class="btn password_cancel_btn"
                        >Cancel</a
                    >
                    <a [routerLink]="['./']" class="btn password_next_btn"
                        >Next</a
                    >
                </div>
            </div>
        </div>
    </div>
</div>
<app-pop-up></app-pop-up>
